"use client"
import type { Theme } from '@mui/material'
import { useTheme } from '@mui/material/styles'
import useMediaQuery from '@mui/material/useMediaQuery'

export function useIsMobile() {
  const theme = useTheme()
  return useMediaQuery<Theme>(theme.breakpoints.down('md'))
}
